import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HeaderModule } from './core/components/header/header.module';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  imports: [HeaderModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService.current();
  }
}
